import { gql } from '@apollo/client';

// 獲取配對建議
export const GET_MATCHING_SUGGESTIONS = gql`
  query GetMatchingSuggestions($limit: Int) {
    matchingSuggestions(limit: $limit) {
      success
      message
      suggestions {
        userId
        username
        score
        totalWeight
        answeredQuestions
        totalQuestions
        selfIntroduction
      }
      totalCount
      errors {
        field
        message
      }
    }
  }
`;

// 獲取使用者的第一個自我介紹
export const GET_USER_FIRST_PROFILE = gql`
  query GetUserFirstProfile($userId: ID!) {
    userProfiles(userId: $userId, contentType: TEXT, limit: 1) {
      success
      message
      profiles {
        id
        content
        visibility
        order
      }
      errors {
        field
        message
      }
    }
  }
`;

// 創建配對請求
export const CREATE_MATCHING = gql`
  mutation CreateMatching($targetUserId: ID!) {
    createMatching(targetUserId: $targetUserId) {
      success
      message
      matching {
        id
        score
        status
      }
      errors {
        field
        message
      }
    }
  }
`;

// 跳過使用者
export const SKIP_USER = gql`
  mutation SkipUser($targetUserId: ID!) {
    skipUser(targetUserId: $targetUserId) {
      success
      message
    }
  }
`;

// 清空跳過使用者列表
export const CLEAR_SKIPPED_USERS = gql`
  mutation ClearSkippedUsers {
    clearSkippedUsers {
      success
      message
    }
  }
`; 